import { SideNavCategory } from '../../../../components/side-nav';
import { StandardReport } from '../../../../models';

function getStandardReportNameById(
  reportId: number,
  categories: Array<SideNavCategory<StandardReport>>,
): string {
  const filteredSearchable = categories.filter(
    (sc) =>
      sc.key !== 'Shared With Me' && sc.key !== 'Saved' && sc.key !== 'Recents',
  );

  const flattenedFilteredSearchable: SideNavCategory<
    StandardReport
  >[] = filteredSearchable.reduce((acc, curr) => {
    return [...acc, ...curr.items];
  }, []);

  const foundStandardReport = flattenedFilteredSearchable.find(
    (fl) => fl.tag.reportId === reportId,
  );

  return foundStandardReport.name;
}

export { getStandardReportNameById };
